/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UxwidgetUw } from '../../models/uxwidget-uw';

export interface GetAclWidgets$Params {
}

export function getAclWidgets(http: HttpClient, rootUrl: string, params?: GetAclWidgets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UxwidgetUw>>> {
  const rb = new RequestBuilder(rootUrl, getAclWidgets.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UxwidgetUw>>;
    })
  );
}

getAclWidgets.PATH = '/api/AclRole/allAclWidgets';
